/**
 * URLParser module for extracting and validating Steam IDs from URLs
 * ES Module version for web UI
 */

/**
 * Checks if a URL is a valid Steam URL
 * @param {string} url - The URL to validate
 * @returns {boolean} - True if the URL is a valid Steam URL, false otherwise
 */
export function isValidSteamURL(url) {
    if (typeof url !== 'string' || url.trim() === '') {
        return false;
    }

    try {
        const urlObj = new URL(url);

        // Check for valid Steam domains
        const validDomains = ['store.steampowered.com', 'steamcommunity.com'];
        if (!validDomains.includes(urlObj.hostname)) {
            return false;
        }

        // Check for /app/{STEAM_ID} pattern in the pathname
        const appPattern = /^\/app\/(\d+)/;
        return appPattern.test(urlObj.pathname);
    } catch (error) {
        return false;
    }
}

/**
 * Parses a Steam URL and extracts the Steam ID
 * @param {string} url - The Steam URL to parse
 * @returns {string|null} - The extracted Steam ID or null if parsing fails
 */
export function parseSteamURL(url) {
    if (!isValidSteamURL(url)) {
        return null;
    }

    try {
        const urlObj = new URL(url);
        const appPattern = /^\/app\/(\d+)/;
        const match = urlObj.pathname.match(appPattern);

        if (match && match[1]) {
            return match[1];
        }

        return null;
    } catch (error) {
        return null;
    }
}
